import React from 'react';

class Process extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.toggle = this.toggle.bind(this);
  }
  toggle(e) {
    e.preventDefault();

    this.setState({ show: !this.state.show });
  }
  render() {
    return (
      <div className="relative z-10 pr-15 md:pr-23 h-full md:select-text">
        <div className="relative bg-gray-light md:bg-auto p-23 md:p-0 h-full">
          <p className="absolute md:relative right-0 top-0 text-72 md:text-48 font-black leading-none text-gray-transparent md:text-pink pr-5 md:pr-0">
            0{this.props.index}
          </p>
          <p className="text-24 md:text-14 lg:text-16 font-black text-green normal-case md:uppercase mb-23 md:mb-0 max-w-50 md:max-w-none">
            {this.props.title}
          </p>

          <p className="text-14 max-w-50 md:max-w-none">
            <span>
              {this.props.text == this.props.shortened ? (
                this.props.text
              ) : process.browser && window.innerWidth < 768 ? (
                this.props.text
              ) : this.state.show ? (
                <>
                  {this.props.text}
                  <a className="text-purple ml-5" href="#" onClick={e => this.toggle(e)} target="_blank">
                    view less
                  </a>
                </>
              ) : (
                <>
                  {this.props.shortened}
                  <a className="text-purple ml-5" href="#" onClick={e => this.toggle(e)} target="_blank">
                    view more
                  </a>
                </>
              )}
            </span>
          </p>
        </div>
      </div>
    );
  }
}

export default Process;
